import React from 'react';
import Crosstab from '../../../containers/Crosstab';

const DataHaul = () => (
  <div>
    <Crosstab dataScreen={'DataHaul'} />
  </div>
);

export default DataHaul;
